import API from "../../../app/api";

export const GetHomeProductBySlug = async (select_types) => {
  try {
    const res = await API.get(`products-home/${select_types}`);
      // console.log("getHomeProductBySlug response:", res);
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch Clean Living products");
    }
    return res.data?.data || [];
  } catch (error) {
    console.error("getdontmissout error:", error);
    return [];
  }
};